import React, { Component } from 'react';
import { connect } from 'react-redux';
import Layout from '../components/Layout';

class NotFound extends Component {
    render() {
        return (
            <Layout>
                <section className="content-header">
                    <h1>
                        Dashboard
                    </h1>
                    <ol className="breadcrumb">
                        <li className="active">Página não encontrada</li>
                    </ol>
                </section>
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box box-warning">
                                <div className="box-header with-border">
                                    <h3 className="box-title">Página não encontrada !</h3>
                                </div>
                                
                                <div className="box-body table-responsive no-padding">
                                    <h2>Ops ! Esta pagina não foi encontrada.</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        );
    }
}  
export default connect(null, null)(NotFound);
